import client from './client';

/**
 * Fetch all available properties matching the given filters
 * @param {Object} filters - Query parameters like type, minPrice, maxPrice, guests, location
 * @returns {Promise<Array>} List of properties
 */
export const getPublicProperties = async (filters = {}) => {
    const { data } = await client.get('/api/public/properties', { params: filters });
    return data;
};

/**
 * Fetch details of a single property (including upcoming bookings)
 * @param {number|string} id - The property ID
 * @returns {Promise<Object>} Property generic details
 */
export const getPropertyById = async (id) => {
    const { data } = await client.get(`/api/public/properties/${id}`);
    return data;
};

/**
 * Fetch pure availability dates for a property
 * @param {number|string} propertyId - The property ID
 * @returns {Promise<Array>} Array of { checkInDate, checkOutDate } objects
 */
export const getPropertyAvailability = async (propertyId) => {
    const { data } = await client.get(`/api/bookings/availability/${propertyId}`);
    return data;
};
